export default {
  backButton: 'All companies',
  backToReport: 'Back to the report',
};
